(function () {
  // Native fallback: scripts calling lenisScrollTo keep working when Lenis is off.
  window.lenisScrollTo = function (target, options) {
    options = options || {};
    var offset = options.offset || 0;
    var behavior = options.immediate ? 'auto' : 'smooth';
    var top;

    if (typeof target === 'number') {
      top = target;
    } else if (target === 'top' || target === 'start') {
      top = 0;
    } else if (target === 'bottom' || target === 'end') {
      top = document.documentElement.scrollHeight;
    } else {
      var el = typeof target === 'string' ? document.querySelector(target) : target;
      if (!el) return;
      top = el.getBoundingClientRect().top + window.pageYOffset;
    }
    window.scrollTo({ top: top + offset, behavior: behavior });
  };

  if (typeof Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;

  // Only run on devices with a mouse/trackpad. Phones and tablets use native scroll.
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
    autoRaf: true,
    anchors: true,
    allowNestedScroll: true,
    respectReducedMotion: true,
  });

  window.lenis = lenis;

  function isScrollLocked() {
    var bodyStyle = window.getComputedStyle(document.body);
    return bodyStyle.overflow === 'hidden' || bodyStyle.overflowY === 'hidden';
  }

  function syncScrollLock() {
    if (isScrollLocked()) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }

  var observer = new MutationObserver(syncScrollLock);
  observer.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });

  syncScrollLock();

  window.lenisScrollTo = function (target, options) {
    lenis.scrollTo(target, options);
  };
})();